export const dateUtil = (date) => {
  let rawTime = date?.toString().split(":").slice(0, 2) ?? "";
  let time = rawTime[0] + ":" + rawTime[1] + " ";
  let suffix = rawTime[0] >= 12 ? "PM" : "AM";
  time += suffix;
  return time;
};
